import React, { useState } from "react";
import { Trash, AlertCircle } from "lucide-react";
import ActionPopup from "@/components/common/ActionPopup";

interface StageDeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  description: string;
  type: 'note' | 'photo';
}

const StageDeleteConfirmationDialog: React.FC<StageDeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  type
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setIsDeleting(true);
    setError(null);
    
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      
      setError(
        error instanceof Error 
          ? error.message 
          : 'Silme işlemi sırasında bir bağlantı hatası oluştu. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.'
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ActionPopup
      isOpen={isOpen}
      icon={<Trash className="h-5 w-5" />}
      iconTone="danger"
      title={title}
      description={
        <div className="space-y-2">
          <p>{description}</p>
          {error && (
            <div className="rounded-md border border-error-600/30 bg-error-50 px-3 py-2 text-left text-error-600 flex items-start gap-2">
              <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}
        </div>
      }
      cancelLabel="İptal"
      confirmLabel="Sil"
      confirmTone="danger"
      loading={isDeleting}
      loadingLabel="Siliniyor..."
      onCancel={() => {
        if (!isDeleting) onClose();
      }}
      onConfirm={handleConfirm}
    />
  );
};

export default StageDeleteConfirmationDialog; 